import React, {createRef, useEffect} from 'react';
import "../../styling/MarkdownStyle.css"
import SideBarMarkdown from './SideBarMarkdown';
import MarkdownBody from './MarkdownBody/MarkdownBody';

/**
 * This component renders the markdown in aboutPage page.
 * Markdown contains a table of content that is placed at left position
 * and the body content that is placed at the right position.
 */
const AboutPageMarkdown = (props) => {

    const {
        scrollTop
    } = props;

    const arrLength = 8; // Length of titles in markodown
    const subArrLength = 11; // Length of subtitles of title 'Design your page' 
    const [elRefs, setElRefs] = React.useState([]); // Array variable to store all references of title elements 
    const [elSubRefs, setElSubRefs] = React.useState([]); // Array variable to store all references of sub title elements

    /**
     * This useEffect is used to initialize an array with refs and an array with subRefs.
     * Every main ref corresponds to a basic title inside markdown body. 
     * Every subRef corresponds to sub title of  title 'Design your page' inside markdown body.
     */
    useEffect(() => {
      // Initialize elrefs array 
      setElRefs(tempElRefs => (
        Array(arrLength).fill().map((_, i) => tempElRefs[i] || createRef())
      ));
      // Initialize subelrefs array 
      setElSubRefs(tempElSubRefs => (
          Array(subArrLength).fill().map((_, i) => tempElSubRefs[i] || createRef())
      ));
      
    }, [arrLength]);

    return(
        <div style={{display: 'flex', flexDirection: 'row' }}>
            <SideBarMarkdown refArray={elRefs} elSubRefs={elSubRefs} scrollTop = {scrollTop}/> {/*  Side table with labels of markdown */}
            <div>&nbsp;&nbsp;</div>
            <MarkdownBody refArray={elRefs} elSubRefs={elSubRefs} scrollTop={scrollTop}/> {/*   Main body of markdown */}
        </div>       
    )
}

export default AboutPageMarkdown;